import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const ScheduleGroupRoutes = defineRoute({
    home: {
        route: {
            path: "/schedule-group",
            component: () => loadView(import("./ScheduleGroupHome.vue")),
        },
    },
    timeTable: {
        route: {
            path: "/schedule-group-time-table",
            component: () => loadView(import("../schedule_time_table/ScheduleTimeTable.vue")),
        },
    },
});
